const SET_TAX_INPUT_IS_VISIBLE = 'SET_TAX_INPUT_IS_VISIBLE';

export { SET_TAX_INPUT_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/TaxInputs/constants.js